import { Route } from '@angular/router';
import { routeChangeActivateGuard, routeChangeDeactivateGuard } from '@seven1/angular/gtm';
import redirectedRoutes from '../../public/data/redirectedRoutes.json';
import { navigationDeactivateGuard } from './routing';
import {
    layoutResolver,
    storyResolver
} from '@seven1/angular-storyblok-components/resolver';
import { environment } from '../environments/environment';


export const appRoutes: Route[] = [
    ...(redirectedRoutes as Route[]),
    {
        path: environment.cms.blogSlug,
        loadChildren: () => import('./pages/blog').then(children => children.blog_routes)
    },
    {
        path: ':categoryId/' + environment.cms.blogSlug,
        loadComponent: () => import('./pages/blog').then((page) => page.BlogCategoryPage),
        resolve: {
            story: storyResolver,
            layout: layoutResolver,
        },
        canActivate: [routeChangeActivateGuard],
        canDeactivate: [routeChangeDeactivateGuard],
    },
    {
        path: ':categoryId/' + environment.cms.blogSlug + '/:articleId',
        loadComponent: () => import('./pages/blog').then((page) => page.BlogArticlePage),
        resolve: {
            story: storyResolver,
            layout: layoutResolver,
        },
        canActivate: [routeChangeActivateGuard],
        canDeactivate: [routeChangeDeactivateGuard],
    },
    {
        path: '**',
        loadComponent: () => import('./cms/page').then(cmp => cmp.CmsPage),
        resolve: {
            story: storyResolver,
            layout: layoutResolver,
        },
        canActivate: [routeChangeActivateGuard],
        canDeactivate: [routeChangeDeactivateGuard, navigationDeactivateGuard],
    },
];
